import { ReactNode } from 'react';
import { InlineText, Text } from '@ardoq/typography';

/**
 * Labels for dashboard-pill UI rendered by `@ardoq/table-filter-bar` components
 * (`LinkButton`, `SettingsButton`, dashboard pill filter input). Pattern A: the
 * package owns the defaults and the consumer threads translated strings in.
 */
export type DashboardPillLabels = {
  linkChartsButton: string;
  linkChartsHint: ReactNode;
  closeButton: string;
  editLinkedCharts: string;
  renameFilter: string;
  deleteFilter: string;
  renameDialogTitle: string;
  filterNameLabel: string;
  filterNameHelperText: string;
  saveButton: string;
  cancelButton: string;
  filterInputPlaceholder: string;
  settingsAriaLabel: (filterLabel: string) => string;
};

export const defaultDashboardPillLabels: DashboardPillLabels = {
  linkChartsButton: 'Link charts',
  linkChartsHint: (
    <Text variant="text2">
      First, use <InlineText variant="text2Bold"> Link charts </InlineText>to
      pick the charts to filter. Dashboard filters only affect linked charts.
    </Text>
  ),
  closeButton: 'Close',
  editLinkedCharts: 'Edit linked charts',
  renameFilter: 'Rename filter',
  deleteFilter: 'Delete filter',
  renameDialogTitle: 'Rename dashboard filter',
  filterNameLabel: 'Filter name',
  filterNameHelperText: 'Give your filter a clear, descriptive label',
  saveButton: 'Save',
  cancelButton: 'Cancel',
  filterInputPlaceholder: 'Search...',
  settingsAriaLabel: (filterLabel: string) =>
    `Edit ${filterLabel} filter settings`,
};
